import {
    Component 
} from "@angular/core";

@Component({
    selector: 'mdk-mo-card-stickers',
    templateUrl: './mo-card-stickers.component.svg'
})
export class MoCardStickersComponent {}